import React, { useState, useEffect, useContext, useMemo } from "react";
import "../../assets/css/message/message.css";
import whatsapp from "../../assets/images/logo/whatshapp.png";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import useNotification from "../../hooks/useNotification";
import { useNavigate, useParams } from "react-router-dom";
import useArticles from "../../hooks/useArticle";
import { AuthContext } from "../../contexts/AuthContext";
import LoaderMessage from "../../components/loader/message/LoaderMessage";
import { formatPrice } from "../../utils/formatPrice";
import useMessage from "../../hooks/useMessage";
import useArticle from "../../hooks/useArticle";
import defaultUser from "../../assets/images/utilisateur/default.jpeg";

import useNotify from "../../hooks/useNotify";
const Message = ({ setAlert }) => {
  const { updateArticleCounter } = useArticle();
  const { sendMessageMail } = useMessage();
  const { id } = useParams();
  const navigate = useNavigate();
  const { findOneArticle } = useArticles();
  const { notifyArticleMessage } = useNotify();
  const { isLoading, setIsLoading, user } = useContext(AuthContext);
  const buyerFullname = useMemo(() => {
    const nom = user?.nom ?? "";
    const prenom = user?.prenom ?? "";
    return `${nom} ${prenom}`.trim();
  }, [user?.nom, user?.prenom]);

  const [buyerEmail, setBuyerEmail] = useState(user?.email ?? "");
  const [buyerTel, setBuyerTel] = useState(user?.tel ?? "");
  const [buyerName, setBuyerName] = useState(buyerFullname);

  useEffect(() => {
    // si user se charge après, on resynchronise
    setBuyerEmail(user?.email ?? "");
    setBuyerTel(user?.tel ?? "");
    setBuyerName(buyerFullname);
  }, [user?.email, user?.tel, buyerFullname]);

  const [contentMessage, setContentMessage] = useState(
    "Je suis interressé par votre annonce.",
  );
  const [oneArticle, setOneArticle] = useState();
  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { label: "Accueil", link: "/" },
    { label: "Vendeur", link: "/" },
    { label: "Details", link: "/" },
    { label: "Envoyer un message" },
  ]);
  const imageBaseUrl = process.env.REACT_APP_ARTICLE_IMAGE;

  useEffect(() => {
    if (!id) return;
    setIsLoading(true);
    findOneArticle(id, () => {
      navigate("/");
    })
      .then((res) => {
        const data = res.data.data;
        setOneArticle(data);
        setBreadcrumbItems([
          { label: "Accueil", link: "/" },
          { label: data?.pseudo, link: "/" },
          { label: data?.titre, link: `/article/details/${id}` },
          { label: "Envoyer un message" },
        ]);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlert({
          message:
            "Une erreur s'est produite lors de la récupération des données de l'annonce.",
          type: "danger",
        });
        console.error("Erreur lors de la récupération de l'article :", err);
      });
  }, [id]);
  const { createNotification } = useNotification();

  /*const sendNotificationToOwner = async (article) => {
    const currentUser = JSON.parse(localStorage.getItem("user"));
    const ownerId = article?.utilisateur?._id;
    
    if (!currentUser || !article?.utilisateur?._id) return;
   
    const fullName = `${currentUser.nom ?? ""} ${currentUser.prenom ?? ""}`.trim();

    const notificationData = {
      id_utilisateur: ownerId,
      id_article: article._id, 
      type: 1,
      message: `Vous avez reçu un message de ${fullName} pour l'annonce ${article.titre} . Message: ${message}`,
      archive: 2,
      vu: 2,
    };

    try {
      await createNotification(notificationData);
    } catch (error) {
      console.error("Erreur notification :", error);
    }
  };*/
  const handleSubmit = (ev) => {
    setIsLoading(true);
    ev.preventDefault();

    const formData = new FormData(ev.target);

    const messageContent = formData.get("message") || contentMessage;
    const fullname = formData.get("buyerFullname") || buyerName;
    const mail = formData.get("buyerEmail") || buyerEmail;
    const tel = formData.get("buyerTel") || buyerTel;

    const messageData = {
      from: mail,
      to: oneArticle?.utilisateur?.email,
      subject: `Nouveau message pour votre annonce: ${oneArticle?.titre}`,

      contentMessage: messageContent,
      fullname,
      tel,
      mail,
    };

    sendMessageMail(messageData)
      .then(() => notifyArticleMessage(oneArticle, messageContent))
      .then(() => {
        setIsLoading(false);
        setContentMessage("");
        navigate(`/message/succes?id=${id}`, {
          state: { id },
        });
      })
      .catch((err) => {
        setIsLoading(false);
        setAlert({
          message:
            "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
          type: "danger",
        });
        console.error("Erreur envoi message mail :", err);
      })
      // .finally(() => {
      //   if (user?._id) {
      //     updateArticleCounter(oneArticle._id, "nbMessage")
      //       .then(() => { })
      //       .catch((err) => console.log(err));
      //   }
      // });
  };

  const renderVendeurPhotoSrc = () => {
    const p = String(oneArticle?.utilisateur?.photo || "").trim();
    if (!p || p === "/default.png") return defaultUser;
    if (/^https?:\/\//i.test(p)) return p;
    if (p.startsWith("/")) return `${imageBaseUrl}${p}`;
    return `${imageBaseUrl}/${p}`;
  };

  return (
    <>
      <hr />
      <div className="container mb-5">
        {isLoading ? (
          <>
            <LoaderMessage />
          </>
        ) : (
          <>
            <Breadcrumb items={breadcrumbItems} />
            <div className="message_container mt-5">
              <form className="message_form" onSubmit={handleSubmit}>
                <div className="message_header">
                  <div className="message_header_vendeur">
                    <div className="position-relative">
                      <img
                        src={renderVendeurPhotoSrc()}
                        className="message_image_vendeur"
                        alt="image_vendeur"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = defaultUser;
                        }}
                      />
                      <div className="message_image_status"></div>
                    </div>
                    <div className="message_info_vendeur">
                      <span className="message_nom">
                        {oneArticle?.pseudo && oneArticle.pseudo}
                      </span>
                      <span className="message_status">En ligne</span>
                      <span className="message_tel">
                        <i
                          class="bi bi-telephone-fill "
                          style={{ marginRight: "5px" }}
                        ></i>
                        {oneArticle?.utilisateur?.tel &&
                          oneArticle.utilisateur.tel}
                      </span>
                    </div>
                  </div>

                  <div>
                    <img
                      src={whatsapp}
                      className="message_logo_whatshapp"
                      alt="whatshapp"
                    />
                  </div>
                </div>

                <div className="message_body">
                  <h1>
                    envoyé un message à{" "}
                    {oneArticle?.pseudo && oneArticle.pseudo}
                  </h1>
                  <h3>Vos informations (acheteur)</h3>

                  <div className="message_buyer_grid">
                    <div className="message_field">
                      <label>Nom complet</label>
                      <input
                        name="buyerFullname"
                        type="text"
                        required
                        value={buyerName}
                        onChange={(e) => setBuyerName(e.target.value)}
                        placeholder="Votre nom complet"
                      />
                    </div>

                    <div className="message_field">
                      <label>Email</label>
                      <input
                        name="buyerEmail"
                        type="email"
                        required
                        value={buyerEmail}
                        onChange={(e) => setBuyerEmail(e.target.value)}
                        placeholder="Votre email"
                      />
                    </div>

                    <div className="message_field">
                      <label>Téléphone</label>
                      <input
                        name="buyerTel"
                        type="tel"
                        value={buyerTel}
                        onChange={(e) => setBuyerTel(e.target.value)}
                        placeholder="Votre numéro"
                        required
                      />
                    </div>
                  </div>

                  <h3>Votre message (obligatoire)</h3>

                  {/* ✅ IMPORTANT : donner un name au textarea */}
                  <textarea
                    name="message"
                    required
                    defaultValue={contentMessage}
                    onChange={(ev) => setContentMessage(ev.target.value)}
                  />
                </div>

                <button type="submit">Envoyer</button>
              </form>
              <div className="message_info">
                <div className="message_decrtiption">
                  <h1>A propos de l'annonce</h1>
                  <p>{oneArticle?.titre && oneArticle.titre}</p>
                  {oneArticle?.prix && oneArticle.prix > 0 ? (
                    <p className="message_color_red to">
                      {formatPrice(oneArticle.prix)} MGA
                    </p>
                  ) : null}
                </div>

                <div className="message_info_cle d-none">
                  <h1>Les informations clés</h1>
                  {oneArticle?.infoCle && oneArticle.infoCle.length > 0 ? (
                    <>
                      {oneArticle.infoCle.map((info, index) => {
                        return (
                          <>
                            <h5>{info.name}</h5>
                            <p>{info.value}</p>
                          </>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <h5>Aucune information clé</h5>
                    </>
                  )}
                </div>

                <div className="message_info_cle">
                  <h1>Description</h1>
                  <div className="content_description">
                    {oneArticle?.description
                      ? oneArticle?.description
                        .split(/\r?\n/)
                        .map((line, index) => (
                          <div
                            className="texte_description"
                            key={index}
                            style={{ marginLeft: "0 !important" }}
                          >
                            {line}
                            <br />
                          </div>
                        ))
                      : "Aucune description disponible"}
                  </div>
                </div>
                <div className="message_info_localisation">
                  <h1>Localisation</h1>
                  <p className="message_color_red text-uppercase">
                    {" "}
                    {oneArticle?.ville && oneArticle.ville}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Message;
